export default __webpack_public_path__ + "static/media/Noo Saro-Wiwa.c7e7e980.jpg";